import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type CoverageAreaTableMessages = TableColumnsMessages &
  PopoverMessages & {
    // Column Messages
    cepStartColumn: string;
    cepEndColumn: string;
    areaDescriptionColumn: string;
    startWeightColumn: string;
    endWeightColumn: string;
    freightChargeOrderColumn: string;
    freightCostCarrierColumn: string;
    regionalDeliveryTimeColumn: string;
    freightTypeColumn: string;
  };

export const COVERAGE_AREA_TABLE_MESSAGES: CoverageAreaTableMessages = {
  // Column Messages
  cepStartColumn: "CEP Inicial",
  cepEndColumn: "CEP Final",
  areaDescriptionColumn: "Descrição da Área",
  startWeightColumn: "Peso Inicial(Kg)",
  endWeightColumn: "Peso Final(Kg)",
  freightChargeOrderColumn: "Frete Cobrado",
  freightCostCarrierColumn: "Frete Pago",
  regionalDeliveryTimeColumn: "Prazo de Entrega",
  freightTypeColumn: "Tipo de Frete",

  ...TABLE_COLUMNS_MESSAGES,
  ...POPOVER_MESSAGES,
};
// no default export
